<!--
 * @Description: 首页 -- 移动端
-->

<template>
	<main class="m-public-bg m-index">
		<Energy />
		<Masters />
		<LazyMount>
			<TeacherConsultation />
			<FameTeacher />
			<TopTeacher />
			<More />
			<Privilege />
		</LazyMount>
	</main>
</template>

<script setup>
import { defineAsyncComponent, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { logEvent } from "~/utils/firebase";
import { useUserStore } from "~/stores/user";
import usePixel from "~/hooks/usePixel";
import Energy from "./components/energy/index.vue";
import Masters from "./components/masters/index.vue";
import LazyMount from "../components/lazy-mount/index.vue";

const TeacherConsultation = defineAsyncComponent(
	() => import("./components/teacher-consultation/index.vue")
);
const FameTeacher = defineAsyncComponent(() => import("./components/fame-teacher/index.vue"));
const TopTeacher = defineAsyncComponent(() => import("./components/top-teacher/index.vue"));
const More = defineAsyncComponent(() => import("./components/more/index.vue"));
const Privilege = defineAsyncComponent(() => import("./components/privilege/index.vue"));

const { isLogin } = storeToRefs(useUserStore());
const { reportGooglePixelEvent } = usePixel();

const isPageReload = () => {
	if (!import.meta.client) return false;
	const navigation = performance.getEntriesByType("navigation")?.[0];
	return navigation?.type === "reload";
};

onMounted(async () => {
	if (isPageReload()) {
		await refreshNuxtData();
	}

	try {
		logEvent("seeronnet_home_show");
		reportGooglePixelEvent("gw_index_page_view");
	} catch (error) {
		console.error("埋点事件发送失败:", error);
	}
});
</script>

<style lang="scss" scoped>
.m-index {
	background: #ffffff;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding-bottom: 100px;
}
</style>
